import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Reviews() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/reviews`)
      .then((res) => setReviews(res.data))
      .catch(() => setReviews([]));
  }, []);

  return (
    <section id="reviews" data-testid="reviews-section" className="py-24 bg-zinc-950 border-t border-white/10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6 border-b border-white/10 pb-8">
          <div>
            <h2 className="text-3xl sm:text-5xl font-black uppercase tracking-tighter font-display text-white">
              Client Experiences
            </h2>
            <p className="text-zinc-400 text-sm sm:text-base mt-2">
              Verifiable feedback from homeowners and commercial property managers across Brevard County.
            </p>
          </div>
          <div className="text-xs font-mono text-zinc-400 uppercase tracking-widest">Owner-Verified Feedback</div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r) => (
            <div key={r.id} className="p-8 rounded-2xl bg-black border border-zinc-800 flex flex-col justify-between">
              <div>
                <div className="flex items-center gap-1 text-zinc-400 text-xs mb-4">
                  <span>★★★★★</span>
                  {r.tag && <span className="font-mono ml-2 text-zinc-400">{r.tag}</span>}
                </div>
                <p className="text-sm text-zinc-300 leading-relaxed italic">{r.quote}</p>
              </div>
              <div className="mt-6 pt-4 border-t border-zinc-900 text-xs font-mono text-zinc-400">
                <span className="text-white font-bold block">{r.author}</span>
                <span>{r.location}</span>
              </div>
            </div>
          ))}

          <div className="p-8 rounded-2xl bg-zinc-900/40 border border-dashed border-zinc-700 flex flex-col justify-between items-center text-center">
            <div className="my-auto">
              <div className="w-10 h-10 rounded-full bg-zinc-800 border border-zinc-700 flex items-center justify-center mx-auto mb-4 text-xs font-mono text-white">+</div>
              <h4 className="text-sm font-bold uppercase text-white tracking-wide">Share Your Experience</h4>
              <p className="text-xs text-zinc-400 mt-2 max-w-xs">
                Had our crew out for a cleanout recently? Let your Brevard neighbors know how we did.
              </p>
            </div>
            <a
              href="#contact"
              data-testid="submit-review-link"
              className="mt-6 text-xs font-mono uppercase tracking-wider text-white underline underline-offset-4 hover:text-zinc-300 transition-colors"
            >
              Submit a Review
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
